export default __webpack_public_path__ + "static/polish-62805763a341e175cd82a217e49a7e88.png";